import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import useDisableScroll from "../../../hooks/useDisableScroll";

const DirtyStateNavModal = (props) => {
  const { show, close, confirm } = props;
  useDisableScroll(show);
  return (
    <Modal
      type="confirm"
      cancelText="Back"
      cancelButtonColor="red"
      confirmText="Leave this page"
      show={show}
      onClose={close}
      onConfirm={confirm}
      style={{ maxWidth: "90%", width: "690px", top: "5vh", position: "fixed" }}
    >
      <div>
        <Text
          wrapper="h1"
          type="header"
          style={{ marginBottom: "2rem", ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Are you sure?
        </Text>
        <Text
          wrapper="p"
          type="body"
          color="#000000"
          style={{ ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Navigating away from this page will result in any unsaved or unsubmitted changes being
          lost.
        </Text>
        <Text
          wrapper="p"
          type="body"
          color="#000000"
          style={{ ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Are you sure you wish to leave this page?
        </Text>
      </div>
    </Modal>
  );
};

export default DirtyStateNavModal;
